import dayjs, { Dayjs } from 'dayjs';

import { BalanceJobType, UserRole } from 'v2/constants';

export interface ScheduleBalanceForm {
  schedules: ScheduleBalance[];
}

export type ScheduleBalance = {
  id?: string;
  balance: number;
  time: Dayjs;
  isEnabled: boolean;
  roles: UserRole[];
  type: BalanceJobType;
};

export const SCHEDULE_BALANCE: ScheduleBalance = {
  balance: 1000,
  time: dayjs(),
  type: BalanceJobType.BY_DEFAULT,
  roles: [UserRole.DEFAULT_USER],
  isEnabled: true,
};
